const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export const API_ENDPOINTS = {
  CLIENTS: `${API_BASE_URL}/clients`,
  STATE_REGISTRATIONS: `${API_BASE_URL}/state-registrations`,
  DOCUMENTS: `${API_BASE_URL}/documents`,
  FUNDS: `${API_BASE_URL}/funds`,
  SPONSFI: {
    FORM_990: {
      SUMMARY: `${API_BASE_URL}/sponsfi/form990/summary`,
      TAX_DOCUMENTS: `${API_BASE_URL}/sponsfi/form990/tax-documents`,
      GENERATE: `${API_BASE_URL}/sponsfi/form990/generate`,
      QUESTIONNAIRE: `${API_BASE_URL}/sponsfi/form990/questionnaire`
    }
  }
} as const;

export const API_CONFIG = {
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  HEADERS: {
    'Content-Type': 'application/json',
  }
} as const; 